{
    "ChannelCode": "Codice",
    "Components": {
        "MeetingEnd": {
            "FeedbackConfirmation": {
                "ExploreMoreFeatures": "Esplora altre funzionalità",
                "ThanksMessage": "Grazie per aver partecipato,",
                "WorkingMessage": "speriamo che la traduzione abbia reso l'evento migliore per voi."
            },
            "FeedbackForm": {
                "FeedbackQuestion": "Com'è stata la qualità della traduzione?",
                "SessionClosedMessage": "La traduzione dal vivo è terminata.",
                "ThankYouMessage": "Speriamo che sia stato d'aiuto!"
            }
        }
    },
    "Continue": "Continua",
    "Control": {
        "Original": "Originale",
        "Spacing": "Spaziatura",
        "TextSize": "Testo",
        "Tts": "TTS"
    },
    "Download": "Scarica",
    "Idle": "Inattivo",
    "Join": "Partecipa",
    "LanguageSettings": "Lingua",
    "Live": "In corso",
    "Loading": {
        "Entering": "Ingresso nel canale",
        "Joining": "Accesso al canale"
    },
    "OK": "OK",
    "Pages": {
        "Home": {
            "EnterEventCodeMessage": "Per favore, inserisci il codice canale.",
            "InputPlaceholder": "Inserisci il codice del canale",
            "Title": "Partecipa. Comprendi tutto."
        },
        "SelectLanguage": {
            "SearchEmpty": "Nessuna lingua corrispondente",
            "SearchPlaceholder": "Cerca lingua",
            "Title": "Scegli la lingua di traduzione"
        }
    },
    "Pane": {
        "CatchUp": "Vai al più recente",
        "Source": "Originale",
        "Translation": "Traduzione",
        "Tts": "Sintesi vocale",
        "TtsShort": "TTS"
    },
    "Share": "Condividi",
    "SpeechSpeed": "Velocità voce",
    "Start": "Avvia",
    "Submit": "Invia",
    "Tips": {
        "Error": {
            "Channel": {
                "LimitExceeded": "Questo canale ha raggiunto il limite di connessioni."
            }
        },
        "Icon": {
            "ScrollToBottom": "Torna al più recente",
            "ShareLink": "Condividi link",
            "SpeechRate": "Imposta velocità di riproduzione"
        }
    },
    "Toast": {
        "LanguageChanged": "Lingua di traduzione: {lang}",
        "LinkCopied": "Link copiato",
        "SourceOff": "Originale nascosto",
        "SourceOn": "Originale mostrato",
        "TtsOff": "Voce disattivata",
        "TtsOn": "Voce attivata"
    },
    "Transcript": {
        "Start": "Inizio della trascrizione"
    },
    "tutorialPage": {
        "downloadOverlay": {
            "originText": "Testo Originale",
            "summary": "Riepilogo",
            "transcript": "Trascrizioni"
        },
        "translationLanguage": {
            "title": "Lingua di traduzione"
        }
    }
}
